import { render, staticRenderFns } from "./AIPromptSuggestion.vue?vue&type=template&id=e6209a38&scoped=true"
import script from "./AIPromptSuggestion.vue?vue&type=script&lang=js"
export * from "./AIPromptSuggestion.vue?vue&type=script&lang=js"
import style0 from "./AIPromptSuggestion.vue?vue&type=style&index=0&id=e6209a38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6209a38",
  null
  
)

export default component.exports